"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrosoftTeamsClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class MicrosoftTeamsClient extends authenticated_client_1.AuthenticatedClient {
    getTenantInformation(tenantId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(`/v1/microsoft-teams/${tenantId}/tenant-information`);
            return payload;
        });
    }
    checkTeamsAppTenantAvailability(tenantId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(`/v1/microsoft-teams/${tenantId}/teams-app-tenant-availability`);
            return payload;
        });
    }
    getTeamsInTenant(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(`/v1/projects/${projectId}/microsoft-teams/teams`);
            return payload;
        });
    }
    getChannelsInTeam(projectId, teamId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(`/v1/projects/${projectId}/microsoft-teams/teams/${teamId}/channels`);
            return payload;
        });
    }
    createMessageConfiguration(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpPost(`/v1/projects/${projectId}/microsoft-teams/message-configurations`, request);
            return payload;
        });
    }
    getMessageConfiguration(projectId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = filters ? `?entityType=${filters.entityType}&entityId=${filters.entityId}` : '';
            const { payload } = yield this.httpGet(`/v1/projects/${projectId}/microsoft-teams/message-configurations${queryString}`);
            return payload;
        });
    }
    getMessageConfigurationById(projectId, messageConfId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(`/v1/projects/${projectId}/microsoft-teams/message-configurations/${messageConfId}`);
            return payload;
        });
    }
    updateMessageConfigurationById(projectId, messageConfId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpPut(`/v1/projects/${projectId}/microsoft-teams/message-configurations/${messageConfId}`, request);
            return payload;
        });
    }
    deleteMessageConfigurationById(projectId, messageConfId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpDelete(`/v1/projects/${projectId}/microsoft-teams/message-configurations/${messageConfId}`);
            return payload;
        });
    }
}
exports.MicrosoftTeamsClient = MicrosoftTeamsClient;
//# sourceMappingURL=microsoft-teams.client.js.map